import React from 'react';

type Props = {
    overlay?: boolean;
};

const Loader: React.FC<Props> = ({overlay}) => {
    {
        return overlay ? (
            <div className="loader-overlay">
                <ul className="loader">
                    <li />
                    <li />
                    <li />
                </ul>
            </div>
        ) : (
            <ul className="loader">
                <li />
                <li />
                <li />
            </ul>
        );
    }
};

export default Loader;
